import React from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom'
import _ from 'lodash';
import SessionStorageService from '../services/utilities/SessionStorageService';
import AuthProvider, { needTokenUpdate } from '../utilities/authProvider';
import LocalStorageService from '../services/utilities/LocalStorageService';

export const Tracker = () => {
  const trackerWebComponent = React.useRef();
  const history = useHistory();

  React.useEffect(() => {
    customElements.whenDefined('tracker-web-component').then(() => {
      trackerWebComponent.current.setProps({
        title: 'aaa123',
        toNotFound: () => {
          history.replace(location.pathname, { isNotFound: true });
        },
        // request.jsのwithTokenを参考に実装
        getToken: async () => {
          let token = SessionStorageService.getToken();
          if (token === null) {
            await AuthProvider.instance.redirectLoginPage();
            return '';
          }
          if (needTokenUpdate(token)) {
            token = await AuthProvider.instance.silentTokenUdate();
          }
          if (token === null) {
            await AuthProvider.instance.redirectLoginPage();
            return '';
          }
          return token;
        },
        throwErrorShell: (error) => {
          window.location.replace('/error-500');
        },
        getUserInfo: () => {
          const roleId = parseInt(LocalStorageService.getItem('role_id'), 10);
          return { roleId };
        }
      });
    });
  });

  return (
    <React.Fragment>
      <Helmet>
        <script type="text/javascript" async src={process.env.REACT_APP_TRACKER_URL}></script>
      </Helmet>
      <tracker-web-component ref={trackerWebComponent} />
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/Tracker.jsx